import WithApplicationId from 'utils/WithApplicationId';
import CompanyAddressStepWithApplicationId from './components/CompanyAddressStepWithApplicationId/CompanyAddressStepWithApplicationId';

export default WithApplicationId({
	Component: CompanyAddressStepWithApplicationId,
	stepName: 'How do we find you?',
});
